import { useState } from "react";
import Button from "../Button";
import { useNavigate } from "react-router-dom";
const JoinWaitList = ({handleClose}) => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [countryCode, setCountryCode] = useState('+91');
  const [alertMessage, setAlertMessage] = useState('');
  const navigate = useNavigate();

  const handleContact = (e) => {
    e.preventDefault();
    if (!name || !email || !phone) {
      setAlertMessage('Please fill all fields.');
      return;
    }
    setAlertMessage('You’ve joined the waitlist!');
    console.log({ name, email, phone: `${countryCode} ${phone}` });
    setTimeout(() => {
      navigate("/thank-you");
    }, 2000);  };

  return (
    <div className="max-w-xl mx-auto bg-gray-900 rounded-xl shadow-lg p-6 md:p-10 text-white mt-10">
      <Button
        onClick={handleClose}
        variant="addsection"
        className="absolute top-12 right-2 text-md rounded-full bg-gray-800 hover:bg-gray-700"
      >
        ✕
      </Button>

      <h2 className="text-3xl font-semibold text-center mb-6">
      GET A CUSTOM <span className="text-primary">QUOTE</span>
      </h2>
      
      {alertMessage && (
        <div className="bg-green-600 text-white p-3 rounded mb-4 text-center text-sm">
          {alertMessage}
        </div>
      )}

      <form onSubmit={handleContact} className="space-y-5">
        <input
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Name *"
          required
          className="w-full px-4 py-2 rounded bg-gray-800 border border-gray-700 focus:outline-none focus:ring-2 focus:ring-primary"
        />
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Email *"
          required
          className="w-full px-4 py-2 rounded bg-gray-800 border border-gray-700 focus:outline-none focus:ring-2 focus:ring-primary"
        />
        <div className="flex gap-3">
          <input
            type="text"
            value={countryCode}
            onChange={(e) => setCountryCode(e.target.value)}
            placeholder="+91"
            required
            className="w-1/4 px-4 py-2 rounded bg-gray-800 border border-gray-700 focus:outline-none"
          />
          <input
            type="tel"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            placeholder="Phone Number *"
            required
            className="w-3/4 px-4 py-2 rounded bg-gray-800 border border-gray-700 focus:outline-none"
          />
        </div>

        <Button
          type="submit"
          variant="solid"
          className="w-full"
        >
          GET A CUSTOM QUOTE
        </Button>

      </form>
    </div>
  );
};

export default JoinWaitList;
